import React, { useEffect } from "react"
import { I18nextProvider } from "react-i18next"
import i18next from "../../translations/i18n"
import { extractLangAndCountry } from "../../utility/lang"
import { saveTrackingCookies } from "../../utility/cookie"

export const PageContext = React.createContext({})

const Page = ({ children, context, ...props }) => {
  const pageInformation = buildContext(context)
  i18next.changeLanguage(pageInformation.folder.split("-").join(""))

  useEffect(() => {
    window.dataLayer = window.dataLayer || []

    if (window.HubSpotCallsToActions) {
      window.HubSpotCallsToActions.refresh();
      // console.log("refresh CTA")
    } else {
      window.hsCallsToActionsReady = [
        () => {
          if (window.HubSpotCallsToActions) {
            window.HubSpotCallsToActions.refresh();
            // console.log("refresh CTA")
          }
        },
      ];
    }

    setTimeout(() => {
      saveTrackingCookies()
      window.dataLayer.push({
        event: 'virtualPageview',
        vPageURL: window.location.href,
        vPageTitle: window.document.title,
        pageSection: props.analitycsSection ? props.analitycsSection : null,
        market: pageInformation.lang
      })
    }, 100)
  })

  return <PageContext.Provider value={pageInformation}>
    <noscript>
      <iframe src="https://sgtm.fabrick.com/ns.html?id=GTM-MN3W72HK" title="GTM" height="0" width="0" style={{ display: "none", visibility: "hidden" }} />
    </noscript>
    <I18nextProvider i18n={i18next}>
      {children}
    </I18nextProvider>
  </PageContext.Provider>
}

export default Page

const buildContext = (context) => {
  const folder = context.folder ? context.folder : extractFolder(context.path)
  const { lang, country } = extractLangAndCountry(folder)

  return {
    lang,
    country,
    folder,
    path: context.pageUrl,
    hiddenInProduction: isHidePage(context),
    hasTapToPayBreadcrumbs: context.hasTapToPayBreadcrumbs,
    layout: {
      headerFixed: context && context.headerFixed ? true : false,
      headerType: context && context.headerType ? context.headerType : "full",
      headerTheme: context && context.headerTheme ? context.headerTheme : "light",
      footerType: context && context.footerType ? context.footerType : "full",
      footerTheme: context && context.footerTheme ? context.footerTheme : "dark",
      headerIsTransparent: context && context.headerIsTransparent ? context.headerIsTransparent : false,
    },
    page: {
      breadcrumb: context.breadcrumb ? context.breadcrumb : false,
      prismic: context.created_by_node_prismic ? context.created_by_node_prismic : false,
      alternate: context.alternatePages ? context.alternatePages : {},
      custom_type: context.custom_type ? context.custom_type : false
    }
  }
}

const extractFolder = (path) => {
  if (path) {
    const start = path.substring(1, 6)
    if (start.indexOf("hide") !== -1) {
      const lang = path.substring(7, 11)
      return /[a-z]{2}-[a-z]{2}$/.test(lang) ? lang : "en-gb"
    } else {
      return /[a-z]{2}-[a-z]{2}$/.test(start) ? start : "en-gb"
    }
  }

  return "en-gb"
}

const isHidePage = (context) => {
  if (context.hiddenInProduction) {
    return true
  }

  if (context.path && context.path.indexOf('/hide/') !== -1) {
    return true
  }

  return false
}